import {
    call, put, take, takeEvery, takeLatest 
} from "redux-saga/effects";
import {
    getId,
    injectApiWithContextFactory,
    injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";
import {
    LOAD_REQUESTED,
    defaultScopeId,
    loadProjectsFailed,
    loadProjectsSucceeded,
} from "./projects.duck";
import { loadProjects } from "./projects.api";
import noop from "lodash.noop";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        loadProjectsSucceeded,
        loadProjectsFailed,
    },
    getId,
    defaultScopeId
);

export const withApiContext = injectApiWithContextFactory(
    {
        loadProjects,
    },
    injectBoundGQLClient
);

function* loadRequested({
    api: { loadProjects = noop },
    actions: { loadProjectsSucceeded, loadProjectsFailed },
    resolve = noop,
    reject = noop,
}) {
    try {
        const projects = yield loadProjects();
        yield loadProjectsSucceeded(projects);
        yield call(resolve);
    } catch (error) {
        yield loadProjectsFailed(error);
        yield call(reject, error);
    }
}

export default () =>
    function* rootSaga() {
        yield takeLatest(
            LOAD_REQUESTED,
            withApiContext(withBoundActions(loadRequested))
        );
    };
